import {Button, Col, Row, Space} from "antd";
import {StyledPageHeader} from "../../../../styles/dashboard/calls/calls";
import {Link} from "react-router-dom";
import {StyledPageHeaderWrapper} from "../../../../components/calls/upcoming-calls/upcoming-calls.style";
import {PropsWithChildren} from "react";
import {useGetDiscountCodesContext} from "../context";
import {StyledCreateButtonWrapper} from "../../../../layouts/dashboard-wrapper/dashboard-wrapper.style";
import {PlusOutlined, VideoCameraOutlined} from "@ant-design/icons";
import {TourWidget} from "../../../../components/widgets/tour-widget";

type DiscountsPageLayoutProps = PropsWithChildren;

export function DiscountCodesPageLayout({children}: DiscountsPageLayoutProps) {
  const {
    state: {discountCodes},
  } = useGetDiscountCodesContext();
  // console.log({discountCodes});

  const hasDiscountCodes = discountCodes.length > 0;
  return (
    <Row gutter={[39, 50]} style={{marginTop: "1.5rem"}}>
      <Col xl={{span: 16}} style={{width: "100%"}}>
        <StyledPageHeaderWrapper>
          <StyledPageHeader>Discounts</StyledPageHeader>
          {hasDiscountCodes && (
            <StyledCreateButtonWrapper style={{display: "flex", justifyContent: "end"}}>
              <div>
                <Link to="/discounts/new">
                  <Button type="primary" size="small">
                    <span className="show-desktop">Create a discount code</span>
                    <span className="show-mobile">
                      <PlusOutlined style={{fontSize: "2.4rem"}} />
                    </span>
                  </Button>
                </Link>
              </div>
            </StyledCreateButtonWrapper>
          )}
        </StyledPageHeaderWrapper>
        {children}
      </Col>
      <Col span={24} lg={{span: 8}}>
        <div className="widget-area">
          <Space direction="vertical" size={32} style={{display: "flex"}}>
            <TourWidget
              textInfo="Watch a video guide on how to create and apply discount codes to any of your offerings."
              buttons={[
                <Button
                  href="https://www.loom.com/share/498905be77894cd9b191ec990b903e4a?sid=421cac07-e45c-4b49-9084-ff8ebfca0e9c"
                  block
                  icon={<VideoCameraOutlined />}
                  size="small"
                  target="_blank"
                >
                  <span>Watch demo video</span>
                </Button>,
              ]}
            />
          </Space>
        </div>
      </Col>
    </Row>
  );
}
